import { useEffect, useState } from "react";

interface DelayMountProps {
  isMounted: boolean;
  delayTime: number;
}

// particularly useful when using animations on conditionally rendered components
const useDelayUnmount = ({isMounted, delayTime}: DelayMountProps) => {
  const [showItem, setShowItem] = useState(false);
  
  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    if (isMounted && !showItem) {
      setShowItem(true);
    } else if (!isMounted && showItem) {
      timeoutId = setTimeout(() => setShowItem(false), delayTime); //delay our unmount
    } 
    
    return () => clearTimeout(timeoutId);
  }, [isMounted, delayTime, showItem]);

  return showItem;
}

export default useDelayUnmount;